import type { ViewRules } from '../engine';

export const DEFAULT_VIEW_RULES: ViewRules = {
  dirQueueMax: 2,
  dirPerTick: 1,
  swipeMinDistPx: 24,
  swipeWindowMs: 250,
  swipeAxisRatio: 1.5,
  edgeDeadzonePx: 16,
  maxFrameDeltaMs: 250,
  maxCatchupTicks: 3,
  gameoverInputLockMs: 400,
  pauseAbandonMs: 1800000,
  cellCssMin: 24,
  cellCssMax: 48,
  bandMinCss: 76,
  bandMaxCss: 104,
  bandFloorCss: 60,
  hudMinCss: 32,
  hudMaxCss: 44,
  hudFloorCss: 28,
  slackToBand: 0.5,
  slackToHud: 0.25,
  marginTopRatio: 0.3333,
  inAppBottomGuardCss: 48,
  relayoutDebounceMs: 150,
  tileFill: 0.8,
  fontLoadTimeoutMs: 1500,
  renderInterpolate: true,
  alphaSteps: 4,
  alphaStepsPenalty: 2,
  boostEnabled: false,
};
